<template>
  <div class="app-container admin-pc-home">
    <div class="admin-pc-home__body">
      <p class="admin-pc-home__title">欢迎进入逻拓后管系统</p>
      <p v-if="displayName" class="admin-pc-home__user">{{ displayName }}，您好</p>
    </div>
  </div>
</template>

<script>
import { getH5AdminUserCache } from '@/api/h5-admin-auth'

export default {
  name: 'H5AdminHome',
  data() {
    return {
      userInfo: getH5AdminUserCache()
    }
  },
  computed: {
    displayName() {
      if (!this.userInfo) return ''
      return this.userInfo.nickName || this.userInfo.username || ''
    }
  }
}
</script>
